import { render } from "./CategoriesGrid.vue?vue&type=template&id=3119be00&scoped=true"
import script from "./CategoriesGrid.vue?vue&type=script&lang=js"
export * from "./CategoriesGrid.vue?vue&type=script&lang=js"

import "./CategoriesGrid.vue?vue&type=style&index=0&id=3119be00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3119be00"]])

export default __exports__